import { useMemo } from "react";
import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import ViewTitle from "../../layout/components/ViewTitle";
import { useBoardViews } from "../../contexts/views/viewsContext";
import Enums from "../../types/enums";

export const OverDueTasks = () => {
  const { systemViews } = useBoardViews();

  const overdueView = useMemo(
    () => systemViews.find((v) => v.ViewType === Enums.ViewType.OverdueTasks),
    [systemViews]
  );

  return (
    <>
      <div className="row">
        <ViewTitle viewId={overdueView?.Id} viewName={overdueView.Name} />
      </div>
      <div className="row">
        <TaskGrid viewId={overdueView?.Id} />
      </div>
    </>
  );
};
